/**
 * @desc 查询费用请款单详情
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<defs.rms.ExpenseReimbursementResponseDto>;
export function request(parentId: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/getExpenseReimbursementDetail/${parentId}`, {
      method: "GET",

      ...options,
    }),
  );
}
